const HomeTabItem = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="23"
            viewBox="0 0 21 23"
            fill="none"
            {...props}
        >
            <path
                d="M19.0051 7.97411C15.4598 3.77593 11.0259 0.411937 10.2642 0.411937C9.50255 0.411937 6.20203 3.88473 5.44037 4.7552C5.25903 4.96375 5.06861 5.20857 5.14115 5.47152C5.21369 5.76168 5.56732 5.90676 5.85747 5.83422C6.13856 5.76168 6.34711 5.48966 6.44685 5.20857C6.53753 4.92748 6.53753 4.62826 6.53753 4.3381C6.53753 3.80313 6.90929 0.720227 6.42872 0.430072C6.27457 0.348466 3.03752 0.457274 2.97405 0.520745C2.90151 0.593284 2.90151 4.54665 3.02846 6.63214C3.06473 7.3394 0.607473 9.33422 0.471462 9.81479C0.371721 10.1593 0.75255 18.5013 0.933898 22.0829C0.933898 22.2371 7.39892 22.1645 7.4624 22.1011C7.52587 22.0376 7.5168 18.6917 7.27198 16.4158C7.27198 16.3161 7.24478 16.2073 7.29918 16.1166C7.38079 15.9534 7.61654 15.9353 7.80695 15.9353C9.62043 15.9534 11.4248 16.0441 13.2202 16.1982C13.3471 16.1982 13.4922 16.2254 13.5829 16.3161C13.6554 16.3886 12.6943 21.9197 13.1114 22.1464C13.5285 22.3731 19.6852 22.4003 20.0207 22.0829C20.1295 21.9832 20.6917 10.3226 20.5375 10.1775C20.4831 9.95986 19.0233 7.95598 19.0233 7.95598"
                stroke="#686058"
                strokeMiterlimit="10"
            />
        </svg>
    )
}

export default HomeTabItem
